// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"96dcf2f4","320":"8c0be387","453":"0fe80303","905":"b6264264"}[chunkId] + ".chunk.js";
};